var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
		fillWidth: _vm.fillWidth,
		highlight: _vm.highlight,
		container__card: !_vm.cardWithoutBackground,
	},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }